import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseState } from "../_types/case-state";

@Injectable({
    providedIn: 'root',
})
export class CasesModesService extends Service<CaseState> {
    public override type = 'caseModes';
    public override url = 'attendance/caseModes';

    //habilita la cache para el metodo all
    public override CACHEABLE_METHODS: any = { all: true };
}
